module.exports = __webpack_public_path__ + "img/OverseaMember08.d12f4a54.jpg";